import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './EnergyCertificatePopoverContent.module.css'

const EnergyCertificatePopoverContent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={`display-flex gap-l padding-m ${styles.container}`}>
      <span className={'font-body-medium-regular'}>
        {t('wizard.screen.construction.energyCertificate.popover.mobile.description1')}
      </span>
      <span className={'font-body-medium-regular'}>
        {t('wizard.screen.construction.energyCertificate.popover.mobile.description2')}
      </span>
    </div>
  )
}

export default EnergyCertificatePopoverContent
